import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, CheckIcon, GiftIcon } from 'lucide-react';
import { bonuses } from '../data/bonuses';
import { bonusTotalValue, totalBonuses } from '../data/offer';
export function BonusSection() {
  return <section className="bg-navy-soft py-16 sm:py-20" aria-labelledby="bonus-title" data-id="element-20" data-mp="22dai8ush2fuc">
      <div className="mx-auto max-w-5xl px-4" data-id="element-21" data-mp="1yet7805xkl7n">
        <div className="text-center" data-id="element-22" data-mp="1anxn7p7puuay">
          <span className="inline-flex items-center gap-2 rounded-full bg-mineral px-4 py-2 text-xs font-extrabold uppercase tracking-[.14em] text-navy" data-id="element-23" data-mp="1aoyvxn19f4pi">
            <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-24" data-mp="1jhamra0acu60" /> Included at no extra cost
          </span>
          <h2 id="bonus-title" className="mt-4 text-3xl font-extrabold text-white sm:text-4xl" data-id="element-25" data-mp="1epitustnqccp">
            The {totalBonuses} Exclusive Bonuses
          </h2>
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-26" data-mp="myuvfojdbl2q">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.article key={bonus.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className={`flex flex-col rounded-xl border border-gold/30 bg-steel p-6 shadow-lg shadow-black/20 ${bonus.wide ? 'md:col-span-2' : ''}`} data-id="element-27" data-mp="29rjt4m8vs98r" data-mpi={index}>
                <div className="flex items-center justify-between gap-4" data-id="element-28" data-mp="1vrikulqadzj9">
                  <div className="flex items-center gap-3" data-id="element-29" data-mp="20roeu8k13y4i">
                    <span className="flex h-10 w-10 items-center justify-center rounded-lg border border-gold/50 bg-navy text-mineral" data-id="element-30" data-mp="20q3kok1mmh76">
                      <Icon className="h-5 w-5" aria-hidden="true" data-id="element-31" data-mp="3c6tu0c1cjp50" />
                    </span>
                    <p className="text-xs font-bold uppercase tracking-[.14em] text-mineral" data-id="element-32" data-mp="3h5n0hki7ufvo">Bonus {bonus.number}</p>
                  </div>
                  <p className="whitespace-nowrap text-xs font-bold text-muted" data-id="element-33" data-mp="1h23xhm3abvcy">
                    <span className="line-through" data-id="element-34" data-mp="1c53rfb6fqslu">Real value {bonus.value}</span>
                    <span className="ml-2 rounded-md bg-mineral px-2 py-1 text-[11px] font-extrabold uppercase tracking-wide text-navy" data-id="element-35" data-mp="1q3tncnhiqm8m">
                      Free
                    </span>
                  </p>
                </div>

                <h3 className="mt-4 text-lg font-bold leading-tight text-white" data-id="element-36" data-mp="ydp8138m8pe9">{bonus.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-muted" data-id="element-37" data-mp="tf468zdptxnp">{bonus.description}</p>

                {bonus.items && <ul className="mt-3 grid gap-1.5 sm:grid-cols-2" data-id="element-38" data-mp="177bzih5sj6hn">
                    {bonus.items.map(item => <li key={item} className="flex gap-2 text-sm leading-snug text-white" data-id="element-39" data-mp="eowx5a9llqzo">
                        <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-mineral" aria-hidden="true" data-id="element-40" data-mp="emk6m8pry8b0" />
                        {item}
                      </li>)}
                  </ul>}

                {bonus.groups && <div className="mt-4 grid gap-6 md:grid-cols-2" data-id="element-41" data-mp="5awfie50nga4">
                    {bonus.groups.map(group => <div key={group.heading} data-id="element-42" data-mp="3msfn1xpbhoof">
                        <p className="text-sm font-bold text-white" data-id="element-43" data-mp="3rp61yhpdye89">{group.heading}</p>
                        <ul className="mt-2 grid gap-1.5" data-id="element-44" data-mp="ja5ootut1a4l">
                          {group.items.map(item => <li key={item} className="flex gap-2 text-sm leading-snug text-muted" data-id="element-45" data-mp="o98s69v4z8ag">
                              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-mineral" aria-hidden="true" data-id="element-46" data-mp="9chr7w5tdoiq" />
                              {item}
                            </li>)}
                        </ul>
                      </div>)}
                  </div>}

                {bonus.cycle && <div className="mt-5" data-id="element-47" data-mp="2yynu73dpvooi">
                    <p className="text-sm font-bold text-white" data-id="element-48" data-mp="3f8ewt7ol7czh">Structured teaching cycle</p>
                    <ol className="mt-2 flex flex-wrap items-center gap-1.5" data-id="element-49" data-mp="3ah6ibx8eh1fg">
                      {bonus.cycle.map((step, stepIndex) => <li key={step} className="flex items-center gap-1.5" data-id="element-50" data-mp="35imvlulzflm1" data-mpi={stepIndex}>
                          <span className="rounded-md border border-gold/50 bg-navy px-2.5 py-1 text-xs font-extrabold uppercase tracking-wide text-mineral" data-id="element-51" data-mp="30klaz58wre8g">
                            {step}
                          </span>
                          {stepIndex < bonus.cycle!.length - 1 && <ArrowRightIcon className="h-3.5 w-3.5 text-gold" aria-hidden="true" data-id="element-52" data-mp="3o7jphxdgwc3q" />}
                        </li>)}
                    </ol>
                  </div>}

                <div className="flex-1" data-id="element-53" data-mp="2crbnpy5v14t4" />
                <p className="mt-4 rounded-lg border-l-4 border-gold bg-navy/60 px-4 py-3 text-sm font-semibold text-white" data-id="element-54" data-mp="27tju8zpkhamt">
                  {bonus.benefit}
                </p>
              </motion.article>;
        })}
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-5 rounded-xl border border-gold bg-navy px-6 py-6 text-center shadow-lg shadow-black/30 sm:flex-row sm:text-left" data-id="element-55" data-mp="s9atrqxl5hw2">
          <div data-id="element-56" data-mp="123jj65rbkuq0">
            <p className="text-xs font-bold uppercase tracking-[.16em] text-muted" data-id="element-57" data-mp="170jr6m7qc7jr">
              Value of all {totalBonuses} bonuses
            </p>
            <p className="mt-1 text-2xl font-extrabold text-muted line-through decoration-gold decoration-2" data-id="element-58" data-mp="1b0tuts81ulvg">
              {bonusTotalValue}
            </p>
          </div>
          <div className="sm:text-right" data-id="element-59" data-mp="1l0ui1p91hm4x">
            <p className="text-xs font-bold uppercase tracking-[.16em] text-muted" data-id="element-60" data-mp="1kzjffsrbykfe">Your price today</p>
            <p className="mt-1 text-3xl font-extrabold text-mineral" data-id="element-61" data-mp="3hufhehhfw9eb">FREE</p>
          </div>
        </div>

        <p className="mt-4 text-center text-xs font-bold uppercase tracking-[.14em] text-mineral" data-id="element-62" data-mp="3mts4928b9ggw">
          Only included in this offer.
        </p>
      </div>
    </section>;
}